// Kiri's reusable character asset component. One consistent placeholder
// character (see kiriAssets.js) driven entirely by a `state` prop — badges
// and animation communicate state instead of needing separate artwork per
// state. Swap kiriAssets.js paths later for final production art; nothing
// here needs to change.
import { Search, ClipboardList, Check, AlertTriangle, HelpCircle } from "lucide-react";
import { KIRI_HERO, KIRI_AVATAR } from "./kiriAssets";

const SIZE_PX = { xl: 128, lg: 84, md: 52, sm: 32, xs: 24 };

const ANIM_CLASS = {
  idle: "kiri-idle",
  listening: "kiri-listening",
  thinking: "kiri-thinking",
  searching: "kiri-searching",
  creating: "kiri-creating",
  success: "kiri-success",
  attention: "kiri-attention",
  error: "kiri-error",
  confirmation: "kiri-attention",
};

const BADGE = {
  searching: { Icon: Search, bg: "bg-[#1B2027]", fg: "text-zinc-300" },
  creating: { Icon: ClipboardList, bg: "bg-[#1B2027]", fg: "text-zinc-300" },
  success: { Icon: Check, bg: "bg-emerald-500", fg: "text-white" },
  attention: { Icon: AlertTriangle, bg: "bg-[#FF5F15]", fg: "text-white" },
  confirmation: { Icon: AlertTriangle, bg: "bg-[#FF5F15]", fg: "text-white" },
  error: { Icon: HelpCircle, bg: "bg-zinc-600", fg: "text-white" },
};

export function KiriCharacter({ state = "idle", size = "md", useHero = false, className = "" }) {
  const px = SIZE_PX[size] || SIZE_PX.md;
  const src = useHero ? KIRI_HERO : KIRI_AVATAR;
  const anim = ANIM_CLASS[state] || "kiri-idle";
  const badge = BADGE[state];
  const ring = state === "attention" || state === "confirmation" ? "kiri-ring-pulse" : "";

  return (
    <div className={`relative inline-block shrink-0 ${className}`} style={{ width: px, height: px }}>
      <img
        src={src}
        alt=""
        draggable={false}
        className={`w-full h-full object-contain ${anim}`}
      />
      {state === "thinking" && (
        <span className="absolute -bottom-0.5 -right-1 flex items-center gap-0.5 bg-[#0B0F14] border border-zinc-700 rounded-full px-1.5 py-1">
          {[0, 150, 300].map((d) => (
            <span key={d} className="w-1 h-1 rounded-full bg-[#FF5F15] animate-bounce" style={{ animationDelay: `${d}ms` }} />
          ))}
        </span>
      )}
      {badge && (
        <span
          className={`absolute -bottom-0.5 -right-0.5 rounded-full ${badge.bg} ${ring} flex items-center justify-center border-2 border-[#0B0F14]`}
          style={{ width: Math.max(16, px * 0.36), height: Math.max(16, px * 0.36) }}
        >
          <badge.Icon className={badge.fg} style={{ width: "58%", height: "58%" }} strokeWidth={2.5} />
        </span>
      )}
    </div>
  );
}
